var LanguageSelector, changeUserLanguage,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

changeUserLanguage = require('../../../../../core/frontend/groupon_modules/changeUserLanguage');

module.exports = LanguageSelector = (function(superClass) {
  extend(LanguageSelector, superClass);

  function LanguageSelector() {
    this.trigger = $('#ls-lang-selected');
    if (this.trigger.length) {
      this.list = $('#ls-lang-list, #ls-lang-list-mobile, #ls-resp-lang-menu');
      this.links = this.list.find('.lang-list-item');
      this.$html = $('html');
      this.hovTimeout = 0;
      this.bind();
    }
  }

  LanguageSelector.prototype.bind = function() {
    var cancelTimer, startTimer;
    startTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout((function() {
          return _this.hideMenu();
        }), 150);
      };
    })(this);
    cancelTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    this.list.on({
      'mouseenter': function() {
        cancelTimer();
      },
      'mouseleave': function() {
        startTimer();
      }
    });
    this.trigger.on({
      'mouseenter': (function(_this) {
        return function() {
          cancelTimer();
          _this.trigger.off('touchstart');
          if (!_this.list.is(':visible')) {
            _this.trigger.trigger('tap');
          }
        };
      })(this),
      'mouseleave': function() {
        startTimer();
      },
      'tap': (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!_this.list.is(':visible')) {
            _this.showMenu();
            _this.setGlobalHideEvent();
          } else {
            _this.hideMenu();
          }
        };
      })(this)
    }).one('touchstart', (function(_this) {
      return function() {
        return _this.trigger.add(_this.list).off('mouseenter mouseleave');
      };
    })(this));
    this.initMenuNavigation(this.trigger, this.list, this.links);
    return this.links.on('click', function(e) {
      var language;
      e.preventDefault();
      e.stopImmediatePropagation();
      language = $(this).data('locale');
      return changeUserLanguage(language);
    });
  };

  LanguageSelector.prototype.showMenu = function() {
    this.trigger.addClass('ls-active');
    return this.list.attr('aria-hidden', 'false').show();
  };

  LanguageSelector.prototype.hideMenu = function() {
    this.list.attr({
      'aria-hidden': 'true'
    }).hide();
    return this.trigger.blur().removeClass('ls-active');
  };

  LanguageSelector.prototype.setGlobalHideEvent = function() {
    return this.$html.one('tap', (function(_this) {
      return function(e) {
        if (!$(e.target).closest('.lang-menu').length) {
          return _this.hideMenu();
        }
      };
    })(this));
  };

  return LanguageSelector;

})(Groupon.AriaMenuNavigation);

